import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UtilsService } from 'src/app/shared/utils.service';
import { DataService } from 'src/app/shared/data.service';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { AddEditProposalComponent } from './add-edit-proposal/add-edit-proposal.component';
import { User } from 'src/app/auth/user.model';
import { AuthService } from 'src/app/auth/auth.service';
import { ValueProposalDetailsComponent } from './value-proposal-details/value-proposal-details.component';

@Component({
    selector: 'app-product-proposal',
    templateUrl: './product-proposal.component.html',
    styleUrls: ['./product-proposal.component.scss'],
    standalone: false
})
export class ProductProposalComponent implements OnInit {
  showSearch: boolean;
  pageEvent!: PageEvent;
  searchForm!: FormGroup;
  currentPage = 0;
  totalSize = 0;
  deleteDialog = false;
  pageSize = 10;
  pageNumber = 1;
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
    usedOnMobile: boolean | null;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null,
    usedOnMobile: null
  };

  departmentsList = new Array<any>();
  searchValue = "";
  productId: any;
  selected = 'manufacturer';
  usedOnMobile = null;
  user: User;
  productName: any;
  departmentId = null;
  departmentName = null;

  constructor(private router: Router, public dialog: MatDialog,
              public utils: UtilsService,
              private route: ActivatedRoute,
              private dataService: DataService,
              public authService: AuthService) {
                this.showSearch = false;
                this.user = this.authService.getUserData();
                this.productId = router.routerState.snapshot.root.children[0].children[0].params.id;
                this.productName = router.routerState.snapshot.root.children[0].children[0].params.name;
                this.route.queryParams.subscribe((params: Params) => {
                if (!this.isEmpty(params)) {
                  this.departmentId = params.departmentId ? params.departmentId : null;
                  this.departmentName = params.departmentName ? params.departmentName : null;
                  this.pageNumber = params.pageNumber ? params.pageNumber : 1;
                  this.pageSize = params.pageSize ? params.pageSize : 10;
                  this.searchValue =  params.searchValue ? params.searchValue : "";
                  this.usedOnMobile = params.usedOnMobile;
                  this.selected = params.usedOnMobile === 'true'  ? 'usedOnMobile'  : 'manufacturer';
                  if (params.usedOnMobile === undefined) {
                    if (this.user.type === this.utils.userTypes.Distributor) {
                      this.usedOnMobile = true;
                    } else {
                      this.usedOnMobile = null;
                    }
                    this.selected = 'usedOnMobile';
                  }
                } else {
                  if (this.user.type === this.utils.userTypes.Distributor) {
                    this.selected = 'usedOnMobile';
                    this.usedOnMobile = true;
                  }
                }
                this.getDepartments();
                if (this.departmentId) {
                  this.openValueProposalDetails(this.departmentId, this.departmentName);
                }
                });
              }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  ngOnInit(): void {
    this.utils.setTitle('Products');
    this.searchForm = new FormGroup({
      search: new FormControl(this.searchValue),
    });

    if (this.searchValue) {
      this.showSearch = true;
    }
    
    this.searchForm.get('search')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.searchValue !== '') {
        setTimeout(() => this.clearSearch(), 0);
      }
    });
  }
  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue,
      usedOnMobile: this.usedOnMobile};
    this.router.navigate(['/products/product/' + this.productId + '/' + this.productName + '/value-proposal'], { queryParams: this.queryParams });
  }
  handleSearchClick() {
    if (this.showSearch && this.departmentsList.length > 0) {
      this.doSearch();
    } else {
      this.showSearch = true;
    }
  }

  doSearch() {
    let searchInput = this.searchForm.get('search')?.value || '';
    this.searchValue = searchInput.trim();
    this.searchForm.get('search')?.setValue(this.searchValue, { emitEvent: false });
    
    if (this.searchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue,
        usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/products/product/' + this.productId + '/' + this.productName + '/value-proposal'], { queryParams: this.queryParams });
    }
  }

  clearSearch() {
    this.showSearch = !this.showSearch;
    this.searchForm.get('search')?.setValue('');
    this.searchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue,
      usedOnMobile: this.usedOnMobile
    };
    this.router.navigate(['/products/product/' + this.productId + '/' + this.productName + '/value-proposal'], { queryParams: this.queryParams });
  }

  filterChange(value: any) {
    this.selected = value;
    if (value === 'manufacturer') {
      this.usedOnMobile = false;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/products/product/' + this.productId + '/' + this.productName + '/value-proposal'], { queryParams: this.queryParams });
    } else if (value === 'usedOnMobile') {
      this.usedOnMobile = true;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/products/product/' + this.productId + '/' + this.productName + '/value-proposal'], { queryParams: this.queryParams });
    }
  }

  addValueProposal() {
    const dialogRef = this.dialog.open(AddEditProposalComponent, {
      disableClose: true,
      width: '400px',
      data: {
        type: 'Add',
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.getDepartments()
    });
  }

  openValueProposalDetails(id: any, name: any) {
    const dialogRef = this.dialog.open(ValueProposalDetailsComponent, {disableClose: true, width: '600px', data: {id, name, selected: this.selected, usedOnMobile: this.usedOnMobile}});
    dialogRef.afterClosed().subscribe((newEvent) => {this.getDepartments()});
  }

  getDepartments() {
    if (this.usedOnMobile ===  null) {
      this.dataService.get('department/RetrieveValueProposalDepartments?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&productId=' + this.productId +
      '&searchKeyword=' + this.searchValue +
      '&AddedBy=2').then((data: any) => {
        if (data.statusCode === 200) {
          this.departmentsList = [];
          const departmentsData = data.data.records;
          this.totalSize = data.data.count;
          departmentsData.forEach((manufacturerData: any) => {
            this.departmentsList.push(manufacturerData);
          });
          if (departmentsData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue,
              usedOnMobile: this.usedOnMobile};
            this.router.navigate(['/products/product/' + this.productId + '/' + this.productName + '/value-proposal'], { queryParams: this.queryParams });
          }
        }
      });
    } else {
      let addedBy = this.usedOnMobile === "true" ? '4' : '2';
      if (this.usedOnMobile === true) {
        addedBy = '4';
      }
      this.dataService.get('department/RetrieveValueProposalDepartments?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&productId=' + this.productId +
      '&searchKeyword=' + this.searchValue +
      '&usedOnMobile=' + this.usedOnMobile +
      '&AddedBy=' + addedBy).then((data: any) => {
        if (data.statusCode === 200) {
          this.departmentsList = [];
          const departmentsData = data.data.records;
          this.totalSize = data.data.count;
          departmentsData.forEach((manufacturerData: any) => {
            this.departmentsList.push(manufacturerData);
          });
          if (departmentsData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue
              , usedOnMobile: this.usedOnMobile};
            this.router.navigate(['/products/product/' + this.productId + '/' + this.productName + '/value-proposal'], { queryParams: this.queryParams });
          }
        }
      });
    }
  }

}
